import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../stores/root-store-context';
import type { IUser } from '../../model/user';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useUserResult {
    isLoaded: boolean;
    user: IUser | null;
}


export const useUser = (user: string | undefined) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState(() => ({
        isLoaded: true,
        user: null
    } as useUserResult));

    useEffect(() => {

        setResult({ isLoaded: false, user: null });

        if (user) {
            rootStore.userStore.loadUser(user)
                .then(() => {
                    setResult({ isLoaded: true, user: rootStore.userStore.users[0] });
                })
                .catch(e => {
                    console.log(e);
                    publishNotification({
                        text: 'Error Loading User',
                        canClose: true
                    });
                });
        } else {
            rootStore.userStore.addUser();
            setResult({ isLoaded: true, user: rootStore.userStore.users[0] });
        }
    }, [publishNotification, rootStore.userStore, user]);

    return result;
};
